import { useQuery } from '@apollo/client';

import { LIST_ASSETS_QUERY } from '@/apollo/schemas/assets/listAssets';
import AddAssetDialog from '@/components/assets/AddAssetDialog';
import { AssetsListTable } from '@/components/assets/AssetsListTable';
import { AssetsTableColumns } from '@/components/assets/TableColumns';
import { useAuth } from '@/context/CoginitoAuthProvider';

const Assets = () => {
  const { session } = useAuth();
  const jwtToken = session
    ? session?.getIdToken().getJwtToken()
    : localStorage.getItem('idToken');

  const { data, refetch, loading } = useQuery(LIST_ASSETS_QUERY, {
    skip: !jwtToken,
    context: {
      headers: {
        identity: jwtToken,
      },
    },
  });

  const assets = data?.listAssets?.assets ?? [];

  return (
    <main className="h-full pb-5">
      <div className="flex justify-between items-center my-4 px-4">
        <h1 className="text-2xl font-bold">Assets Management</h1>
        <AddAssetDialog refetchData={refetch} />
      </div>
      <div className="px-4">
        <AssetsListTable
          columns={AssetsTableColumns({ refetchData: refetch })}
          data={assets}
          isLoadingData={loading}
        />
      </div>
    </main>
  );
};

export default Assets;
